export default {"src":"/_next/static/media/alert-small.36939fa0.svg","height":30,"width":16,"blurWidth":0,"blurHeight":0};